import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { appQueriesStore } from "@/app/api";
import { ROUTES } from "@/app/router";
import { useIntakeFormContext } from "@/features/intake-form/context";
import { ConfettiMinimalisticIcon, FullscreenAlert } from "@/shared/ui";

export const SuccessScreen = () => {
  const {
    actions: { setCompleted },
  } = useIntakeFormContext();

  const queryClient = useQueryClient();

  useEffect(() => {
    setCompleted(true);

    void queryClient.invalidateQueries({
      queryKey: appQueriesStore.user.queryKey,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FullscreenAlert.Root open={true}>
      <FullscreenAlert.Content>
        <FullscreenAlert.Header icon={ConfettiMinimalisticIcon}>
          <FullscreenAlert.Title>
            {t`All set!`}
            <br />
            {t`Enjoy your journey`}
          </FullscreenAlert.Title>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action asChild>
            <Link to={ROUTES.HOME}>{t`Back to Home`}</Link>
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
